import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_TYPES_DISEASE,
} from "../types";


export const getTypesOfDisease = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/disease`);
        dispatch({ type: GET_TYPES_DISEASE, payload: data });
    } catch (error) {
    }
};

export const updateTypesOfDisease = (params) => async (dispatch, getState) => {
    try {
        await api.put(`/disease/${params.disease}`, params);
        await dispatch(getTypesOfDisease());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось обновить запись");
    }
}

export const createTypesOfDisease = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/disease`, data);
        await dispatch(getTypesOfDisease());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteTypesOfDisease = (id) => async (dispatch, getState) => {
    try {
        await api.delete(`/disease/${id}`);
        await dispatch(getTypesOfDisease());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось удалить запись");
    }
};